import { concatLogsAndVars, createEmptyLogsAndVars, recordVariable, ReportingError } from "../diagnostics/clientErrors";
import { sendMessageWithMpcWallet, apiVersion } from "../dwclient/dwcommonutils";
import { jwtMessageAsGetReturnsJson, jwtNoParamReturnsJson, jwtUploadFileReturnsJson } from "../dwclient/jwtcomm";
import { CATEGORY_NODE_TYPE, FILESYSTEM_FILE_NODE_TYPE, FILESYSTEM_FOLDER_NODE_TYPE, META_FILE_NODE_TYPE, BRIDGE_LINK_EDGE_TYPE, CATEGORY_CONTAINS_EDGE_TYPE, FILESYSTEM_CONTAINS_EDGE_TYPE, META_LINK_EDGE_TYPE, CATEGORY_ROOT_NODE_TYPE, FILESYSTEM_ROOT_NODE_TYPE, } from "./graphmodifier2";
export const loadGraph2 = async (storageProps) => {
    return await loadGraphWithParams(storageProps.portalClientId ?? "", storageProps.clientSessionToken ?? "", storageProps.ed25519UserShare ?? "");
};
export const loadGraphWithJwt = async (authToken, signal) => {
    let logsAndVars = createEmptyLogsAndVars("graphloader:loadGraphWithJwt");
    try {
        return await jwtNoParamReturnsJson("get", `/api/${apiVersion}/graph/full`, authToken, signal);
    }
    catch (error) {
        if (signal?.aborted ||
            error?.name === "AbortError" ||
            error?.name === "CanceledError" ||
            error?.code === "ERR_CANCELED") {
            throw error;
        }
        if (isGraphNotFound(error)) {
            return undefined;
        }
        else {
            if (error instanceof ReportingError) {
                logsAndVars = concatLogsAndVars(logsAndVars, error.logsAndVars);
            }
            throw new ReportingError(error, logsAndVars);
        }
    }
};
const loadGraphWithParams = async (portalClientId, clientSessionToken, userShare) => {
    let logsAndVars = createEmptyLogsAndVars("graphloader:loadGraphWithParams");
    recordVariable(logsAndVars, "portalClientId (param)", portalClientId);
    recordVariable(logsAndVars, "clientSessionToken (param)", clientSessionToken);
    const sendObject = {
        method: "get",
        endpoint: `/api/${apiVersion}/graph/full`,
        clientId: portalClientId,
    };
    recordVariable(logsAndVars, "sendObject", sendObject);
    try {
        return await sendMessageWithMpcWallet(clientSessionToken, userShare, sendObject, undefined, undefined, process.env.DWINITY_BACKEND ?? process.env.DWINITY_BACKEND ?? "https://api.dev.dwinity.com");
    }
    catch (error) {
        if (isGraphNotFound(error)) {
            return undefined;
        }
        else {
            if (error instanceof ReportingError) {
                logsAndVars = concatLogsAndVars(logsAndVars, error.logsAndVars);
            }
            throw new ReportingError(error, logsAndVars);
        }
    }
};
// TODO átírni
const isGraphNotFound = (error) => {
    return error?.cause?.response.status === 404;
};
/*export const unProcessAndSaveProcessedGraph2 = async (storageProps: StorageProps, processedGraph: ProcessedGraph2) => {
  //const copyGraph = JSON.parse(JSON.stringify(processedGraph));
  const copyGraph = unprocessGraphNodeValues(processedGraph);
  //console.log("unprocessed", JSON.stringify(copyGraph));
  await saveUnprocessedGraph2(storageProps, copyGraph);
};*/
export const myRemoveGraphJwt = async (authToken) => {
    const sendObject = {};
    return await jwtMessageAsGetReturnsJson("post", `/api/${apiVersion}/graph/reset`, authToken, sendObject);
};
export const unProcessAndSaveProcessedGraphJwt = async (authToken, processedGraph, signal) => {
    //const copyGraph = JSON.parse(JSON.stringify(processedGraph));
    const copyGraph = unprocessGraphNodeValues(processedGraph);
    //console.log("unprocessed", JSON.stringify(copyGraph));
    await saveUnprocessedGraphJwt(authToken, copyGraph, signal);
};
//OK
const unprocessGraphNodeValues = (processedGraph) => {
    const unProcessedGraph = {
        nodes: [],
        edges: [],
        graphInfo: { layers: [...processedGraph.graphInfo.layers] },
    };
    for (const node of processedGraph.nodes) {
        let unProcessedNode;
        switch (node._type) {
            case CATEGORY_NODE_TYPE:
            case CATEGORY_ROOT_NODE_TYPE:
                unProcessedNode = unProcessCategoryNode(node);
                break;
            case FILESYSTEM_FILE_NODE_TYPE:
                unProcessedNode = unProcessFileSystemFileNode(node);
                break;
            case FILESYSTEM_FOLDER_NODE_TYPE:
            case FILESYSTEM_ROOT_NODE_TYPE:
                unProcessedNode = unProcessFileSystemFolderNode(node);
                break;
            case META_FILE_NODE_TYPE:
                unProcessedNode = unProcessMetaFileNode(node);
                break;
            default:
                throw new Error("unprocessing: node._type is unknown: " + node._type);
        }
        unProcessedGraph.nodes.push(unProcessedNode);
    }
    for (const edge of processedGraph.edges) {
        let unProcessedEdge;
        switch (edge._type) {
            case BRIDGE_LINK_EDGE_TYPE:
                unProcessedEdge = unProcessBridgeLinkEdge(edge);
                break;
            case CATEGORY_CONTAINS_EDGE_TYPE:
                unProcessedEdge = unProcessCategoryContainsEdge(edge);
                break;
            case FILESYSTEM_CONTAINS_EDGE_TYPE:
                unProcessedEdge = unProcessFileSystemContainsEdge(edge);
                break;
            case META_LINK_EDGE_TYPE:
                unProcessedEdge = unProcessMetaLinkEdge(edge);
                break;
            default:
                throw new Error("unprocessing: edge._type is unknown: " + edge._type);
        }
        unProcessedGraph.edges.push(unProcessedEdge);
    }
    return unProcessedGraph;
};
const unProcessCategoryNode = (node) => {
    return {
        ...unProcessNodeCommon(node),
    };
};
const unProcessFileSystemFileNode = (node) => {
    return {
        ...unProcessNodeCommon(node),
        size: node.properties?.fileSize ?? node.size ?? 0,
        storagePath: node.storagePath ?? "",
    };
};
const unProcessFileSystemFolderNode = (node) => {
    return {
        ...unProcessNodeCommon(node),
        uploadAllowed: node.uploadAllowed,
    };
};
const unProcessMetaFileNode = (node) => {
    return {
        ...unProcessNodeCommon(node),
        metadataSchema: node.metadataSchema ?? "",
        metadataHash: node.metadataHash ?? "",
        metadataType: node.metadataType ?? "",
        storageKey: node.storageKey ?? "",
        storagePath: node.storagePath ?? "",
        size: node.properties?.fileSize ?? 0,
    };
};
const unProcessNodeCommon = (node) => {
    return {
        _created: node._created,
        _type: node._type,
        id: node.id,
        label: node.label,
        cid: node.cid,
        level: node.level,
        layer: node.layer,
        readonly: node.readonly,
    };
};
const unProcessBridgeLinkEdge = (edge) => {
    return {
        ...unProcessEdgeCommon(edge),
        //fromLayer: edge.fromLayer ?? "",
        //toLayer: edge.toLayer ?? "",
    };
};
const unProcessCategoryContainsEdge = (edge) => {
    return {
        ...unProcessEdgeCommon(edge),
    };
};
const unProcessFileSystemContainsEdge = (edge) => {
    return {
        ...unProcessEdgeCommon(edge),
    };
};
const unProcessMetaLinkEdge = (edge) => {
    return { ...unProcessEdgeCommon(edge) };
};
const unProcessEdgeCommon = (edge) => {
    return {
        _created: edge._created,
        _type: edge._type,
        from: edge.from,
        to: edge.to,
        layer: edge.layer,
        readonly: edge.readonly,
    };
};
/*export const saveUnprocessedGraph2 = async (storageProps: StorageProps, unprocGraph: UnProcessedGraph2) => {
  await saveGraph(storageProps, graphFile);
};*/
export const saveUnprocessedGraphJwt = async (authToken, unprocGraph, signal) => {
    const graphFile = new File([JSON.stringify(unprocGraph)], "graph.json", {
        type: "text/json",
    });
    return saveUnprocessedGraphWithJwt(authToken, graphFile, signal);
};
export const saveUnprocessedGraphWithJwt = async (authToken, graphFile, signal) => {
    return await jwtUploadFileReturnsJson("post", `/api/${apiVersion}/graph/full`, authToken, graphFile, signal);
};
/*export const saveGraph = async (storageProps: StorageProps, file: File) => {
  return await saveGraphWithParams(
    storageProps.portalClientId ?? "",
    storageProps.clientSessionToken ?? "",
    storageProps.ed25519UserShare ?? "",
    file,
  );
};

const saveGraphWithParams = async (
  portalClientId: string,
  clientSessionToken: string,
  userShare: string,
  file: File,
) => {
  const sendObject = {
    method: "post",
    endpoint: `/api/${apiVersion}/graph/full`,
    clientId: portalClientId,
  };
  await uploadFileWithMpcWallet(
    clientSessionToken,
    userShare,
    sendObject,
    file,
    process.env.DWINITY_BACKEND_FOR_GRAPH_STORAGE ?? process.env.DWINITY_BACKEND ?? "https://api.dev.dwinity.com",
  );
};

// TODO átírni
export const saveMusterGraph = async (storageProps: StorageProps) => {
  await saveUnprocessedGraph2(storageProps, MusterGraphTest12);
};
*/
